import React from 'react';
import { Link } from 'react-router-dom';
interface CTAButtonProps {
  text: string;
  link: string;
  variant?: 'primary' | 'secondary';
}
const CTAButton: React.FC<CTAButtonProps> = ({
  text,
  link,
  variant = 'primary'
}) => {
  const baseClasses = 'px-6 py-3 rounded-full font-medium transition-colors duration-300 inline-block';
  const variantClasses = variant === 'primary' ? 'bg-brown text-cream hover:bg-brown-dark' : 'bg-beige text-brown hover:bg-beige-dark border border-brown';
  return <Link to={link} className={`${baseClasses} ${variantClasses}`} data-id="element-32">
      {text}
    </Link>;
};
export default CTAButton;